<div class="mb-3">
  <h1 class="fs-5 fw-bold mb-0">Click Log</h1>
</div>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-header fw-bold bg-tertiary p-3 border-0">
    <h2 class="fs-6 fw-bold mb-0"><i class="bi bi-filter me-2 text-primary"></i>Filters</h2></div>
    <div class="card-body">
      <app-log-filters [filters]="filters" (init)="fetchAll()">
        <div class="row g-3 align-items-end mb-4">
          <div class="col-2">
            <label class="form-label fw-bold small">Bot</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-diagram-3"></i></span>
              <select class="form-select" [(ngModel)]="filters['bot']" [ngModelOptions]="{standalone: true}">
                <option value="">All traffic</option>
                <option value="no-bot">No bots</option>
                <option value="no-denied-bot">No denied bots</option>
              </select>
            </div>
          </div>
          <div class="col-10 text-end">
            <button (click)="downloadCsv()" [disabled]="downloading" class="btn btn-secondary fw-bold me-3">
              @if (downloading) {
                <app-csv-export-progress [current]="exportProgress?.current ?? 0"
                                         [total]="exportProgress?.total ?? 0">
                </app-csv-export-progress>
              } @else {
                CSV
              }
            </button>
            <button type="submit" class="btn btn-primary fw-bold" (click)="applyFilters()">Apply Filters</button>
          </div>
        </div>
      </app-log-filters>

      <app-display-table-column [data]="displayedColumns"></app-display-table-column>

      <div class="table-responsive">
        <table class="table table-striped table-hover table-fixed-columns my-4" id="clicks">
          <thead>
            <tr [tableSorter]="tableSorter" (tableSorterChange)="fetchAll()">
              <th tableSorterHeader="id">ID</th>
              <th tableSorterHeader="createdAt">Date</th>
              @if (displayedColumns.product) {
                <th>Brand</th>
              }
              @if (displayedColumns.offer) {
                <th>Offer</th>
              }
              @if (displayedColumns.conversionType) {
                <th>Conversion Type</th>
              }
              @if (displayedColumns.accountType) {
                <th>Account Type</th>
              }
              @if (displayedColumns.accountManager) {
                <th>Account Manager</th>
              }
              @if (displayedColumns.landingPage) {
                <th>Promotion link</th>
              }
              @if (displayedColumns.partner) {
                <th>Partner</th>
              }
              @if (displayedColumns.country) {
                <th>Country</th>
              }
              @if (displayedColumns.subid) {
                <th>SubID</th>
              }
              @if (displayedColumns.tc1) {
                <th>Tracker 1</th>
              }
              @if (displayedColumns.tc2) {
                <th>Tracker 2</th>
              }
              @if (displayedColumns.tc3) {
                <th>Tracker 3</th>
              }
              @if (displayedColumns.tc4) {
                <th>Tracker 4</th>
              }
              @if (displayedColumns.clickid) {
                <th>Click ID</th>
              }
              @if (displayedColumns.gclid) {
                <th>GCLID</th>
              }
              @if (displayedColumns.gbraid) {
                <th>GBRAID</th>
              }
              @if (displayedColumns.wbraid) {
                <th>WBRAID</th>
              }
              @if (displayedColumns.fbclid) {
                <th>FBCLID</th>
              }
              @if (displayedColumns.fbpxid) {
                <th>FBPXID</th>
              }
              @if (displayedColumns.msclkid) {
                <th>MSCLKID</th>
              }
              @if (displayedColumns.mspxid) {
                <th>MSPXID</th>
              }
              @if (displayedColumns.twclid) {
                <th>TWCLID</th>
              }
              @if (displayedColumns.twpxid) {
                <th>TWPXID</th>
              }
              @if (displayedColumns.ttclid) {
                <th>TTCLID</th>
              }
              @if (displayedColumns.ttpxid) {
                <th>TTPXID</th>
              }
              @if (displayedColumns.source) {
                <th>Source</th>
              }
              @if (displayedColumns.ip) {
                <th>IP</th>
              }
              @if (displayedColumns.referer) {
                <th>Referer</th>
              }
              @if (displayedColumns.userAgent) {
                <th>User Agent</th>
              }
              @if (displayedColumns.bot) {
                <th>Bot</th>
              }
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (click of clicks; track click) {
              <tr>
                <td>
                  <copy-to-clipboard [content]="click.id"></copy-to-clipboard>
                </td>
                <td>{{ click.createdAt | parisDate }}</td>
                @if (displayedColumns.product) {
                  <td>{{ click.product }}</td>
                }
                @if (displayedColumns.offer) {
                  <td>{{ click.offer }}</td>
                }
                @if (displayedColumns.conversionType) {
                  <td>{{ click.offer?.conversionType }}</td>
                }
                @if (displayedColumns.accountType) {
                  <td>{{ click.partner?.accountType }}</td>
                }
                @if (displayedColumns.accountManager) {
                  <td>{{ click.partner?.accountManager }}</td>
                }
                @if (displayedColumns.landingPage) {
                  <td>{{ click.landingPage }}</td>
                }
                @if (displayedColumns.partner) {
                  <td>{{ click.partner }}</td>
                }
                @if (displayedColumns.country) {
                  <td class="text-nowrap">
                    @if (click.country) {
                      <img [ngSrc]="countryService.getFlag(click.country)" [alt]="click.country"
                        [title]="click.country" width="24" height="24" class="me-1">{{ click.country }}
                    }
                  </td>
                }
                @if (displayedColumns.subid) {
                  <td>{{ click.subid }}</td>
                }
                @if (displayedColumns.tc1) {
                  <td>{{ click.tc1 }}</td>
                }
                @if (displayedColumns.tc2) {
                  <td>{{ click.tc2 }}</td>
                }
                @if (displayedColumns.tc3) {
                  <td>{{ click.tc3 }}</td>
                }
                @if (displayedColumns.tc4) {
                  <td>{{ click.tc4 }}</td>
                }
                @if (displayedColumns.clickid) {
                  <td>{{ click.clickid }}</td>
                }
                @if (displayedColumns.gclid) {
                  <td>{{ click.gclid }}</td>
                }
                @if (displayedColumns.gbraid) {
                  <td>{{ click.gbraid }}</td>
                }
                @if (displayedColumns.wbraid) {
                  <td>{{ click.wbraid }}</td>
                }
                @if (displayedColumns.fbclid) {
                  <td>{{ click.fbclid }}</td>
                }
                @if (displayedColumns.fbpxid) {
                  <td>{{ click.fbpxid }}</td>
                }
                @if (displayedColumns.msclkid) {
                  <td>{{ click.msclkid }}</td>
                }
                @if (displayedColumns.mspxid) {
                  <td>{{ click.mspxid }}</td>
                }
                @if (displayedColumns.twclid) {
                  <td>{{ click.twclid }}</td>
                }
                @if (displayedColumns.twpxid) {
                  <td>{{ click.twpxid }}</td>
                }
                @if (displayedColumns.ttclid) {
                  <td>{{ click.ttclid }}</td>
                }
                @if (displayedColumns.ttpxid) {
                  <td>{{ click.ttpxid }}</td>
                }
                @if (displayedColumns.source) {
                  <td>{{ click.source }}</td>
                }
                @if (displayedColumns.ip) {
                  <td>{{ click.ip }}</td>
                }
                @if (displayedColumns.referer) {
                  <td>{{ click.referer }}</td>
                }
                @if (displayedColumns.userAgent) {
                  <td>{{ click.userAgent }}</td>
                }
                @if (displayedColumns.bot) {
                  <td>
                    @if (click.bot) {
                      @if (click.botAllowed) {
                        <span>🟢</span>
                      }
                      @if (!click.botAllowed) {
                        <span>⛔</span>
                      }
                    }
                  </td>
                }
                <td>
                  @if (click.id) {
                    <button (click)="openDetail(click)" class="btn btn-primary btn-sm">
                      <i class="bi bi-eye-fill"></i>
                    </button>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <app-paginator (pageChange)="fetchAll()" [paginator]="paginator"></app-paginator>
    </div>
  </div>
